var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from "../shared/Spinner";
import { Money } from 'v-money';
export default {
    components: { Money: Money, Spinner: Spinner },
    props: {
        applicant: {
            type: Object
        }
    },
    data: function data() {
        return {
            modalName: 'Resident Identity Verification',
            isLoading: false,
            isResetLoading: false,
            applicant_id: "",
            organization_id: "",
            today: null,
            isSsn: false,
            identity: false,
            checkValidation: true,
            validateAddress: {
                isError: false,
                errorMessage: ''
            },
            residentIdentity: {
                firstName: '',
                middleName: '',
                lastName: '',
                email: '',
                phone: '',
                dateOfBirth: '',
                ssn: ''
            },
            answers: {},
            evaluate: {
                pin: ''
            },
            addresses: [],
            applicantValidations: [{ model: 'residentIdentity.firstName', rules: 'required' }, { model: 'residentIdentity.lastName', rules: 'required' }, { model: 'residentIdentity.phone', rules: 'required' }, { model: 'residentIdentity.dateOfBirth', rules: 'required | date | before_or_equal:today' }, { model: 'residentIdentity.ssn', rules: 'required_if:checkValidation | string' }],
            evaluateValidations: []
        };
    },

    computed: {},
    mounted: function mounted() {
        var _this = this;

        Event.$on('Resident Identity Verification', function () {
            _this.$initValidator();
            _this.loadApplicant();
            _this.today = _this.getDOB();
            Event.$emit('open-slide', _this.modalName);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('Resident Identity Verification');
    },

    methods: {
        getDefaultSelection: function getDefaultSelection() {
            return {
                label: "Select ...",
                value: ""
            };
        },
        residentEvaluate: function residentEvaluate() {
            var _this2 = this;

            this.residentIdentity.questions.forEach(function (question) {
                if (!_this2.answers[question.QuestionKeyName]) {
                    _this2.answers[question.QuestionKeyName] = '';
                }
            });

            this.residentIdentity.questions.forEach(function (question) {
                _this2.evaluateValidations.push({ model: 'answers.' + [question.QuestionKeyName], rules: 'required' });
            });

            this.validator.setRules(this.evaluateValidations).validate();

            if (this.validator.fails()) {
                return;
            }
            this.isLoading = true;
            axios.post('/prototype/resident-identity-evaluate', this.prepareResidentEvaluatePayload()).then(function (response) {
                _this2.isLoading = false;
                if (response.data.error) {
                    _this2.$snotify.error("Error Resident Evaluate: " + response.data.error);
                } else {
                    _this2.$snotify.success("Resident Evaluate successfully.");
                    Object.assign(_this2.$data, _this2.$options.data.apply(_this2));
                    Event.$emit("close-slide", _this2.modalName);
                    Event.$emit("view-applicant", _this2.applicant);
                }
            }).catch(function (err) {
                _this2.isLoading = false;
            });
        },
        verifyResidentIdentity: function verifyResidentIdentity() {
            var _this3 = this;

            this.addressValidate();
            this.addresses.forEach(function (address, key) {
                address.state = address.state || _this3.getDefaultSelection();
                _this3.applicantValidations.push({ model: 'addresses.' + key + '.city', rules: 'required' }, { model: 'addresses.' + key + '.state.value', rules: 'required' }, { model: 'addresses.' + key + '.postalCode', rules: 'required' }, { model: 'addresses.' + key + '.country', rules: 'required' }, { model: 'addresses.' + key + '.addressType', rules: 'required' });
            });
            this.validator.setRules(this.applicantValidations).validate();

            if (this.validator.passes() && !this.validateAddress.isError) {
                this.isLoading = true;
                axios.post('/prototype/resident-identity-verify', this.prepareResidentVerificationPayload()).then(function (response) {
                    _this3.isLoading = false;
                    if (response.data.error) {
                        _this3.$snotify.error("Error Resident Identity Verification: " + response.data.error);
                    } else {
                        if (response.data.RiskIndicator.toLowerCase() === 'high') {
                            _this3.$snotify.error("The Resident has failed");
                            Object.assign(_this3.$data, _this3.$options.data.apply(_this3));
                            Event.$emit("close-slide", _this3.modalName);
                            Event.$emit("view-applicant", _this3.applicant);
                        } else {
                            _this3.$snotify.success("Resident Identity verification started successfully.");
                            _this3.identity = true;
                            _this3.residentIdentity.questions = response.data.Questions;
                            Event.$emit("view-applicant", _this3.applicant);
                        }
                    }
                }).catch(function (err) {
                    _this3.isLoading = false;
                });
            }
        },
        prepareResidentEvaluatePayload: function prepareResidentEvaluatePayload() {
            var applicantId = this.applicant_id,
                organizationId = this.organization_id,
                answers = this.answers;

            return {
                applicantId: applicantId,
                organizationId: organizationId,
                answers: answers
            };
        },
        prepareResidentVerificationPayload: function prepareResidentVerificationPayload() {
            this.residentIdentity.ssn = this.residentIdentity.ssn.split("-").join("");

            var applicantId = this.applicant_id,
                organizationId = this.organization_id,
                _residentIdentity = this.residentIdentity,
                firstName = _residentIdentity.firstName,
                lastName = _residentIdentity.lastName,
                middleName = _residentIdentity.middleName,
                email = _residentIdentity.email,
                dateOfBirth = _residentIdentity.dateOfBirth,
                ssn = _residentIdentity.ssn,
                phone = _residentIdentity.phone,
                _addresses = _slicedToArray(this.addresses, 1),
                _addresses$ = _addresses[0],
                streetAddress = _addresses$.streetAddress,
                city = _addresses$.city,
                state = _addresses$.state.value,
                postalCode = _addresses$.postalCode,
                country = _addresses$.country.value,
                addressType = _addresses$.addressType.value;

            return {
                applicantId: applicantId,
                organizationId: organizationId,
                firstName: firstName,
                lastName: lastName,
                middleName: middleName,
                email: email,
                streetAddress: streetAddress,
                city: city,
                state: state,
                postalCode: postalCode,
                country: country,
                addressType: addressType,
                dateOfBirth: moment(dateOfBirth).format("YYYY-MM-DD"),
                ssn: ssn,
                phone: phone
            };
        },
        getDOB: function getDOB() {
            return moment().subtract(18, 'years').format('MM/DD/YYYY');
        },
        loadApplicant: function loadApplicant() {
            var _applicant = this.applicant,
                applicant_id = _applicant.id,
                transunion_property_id = _applicant.property.transunion_property_id;

            this.applicant_id = applicant_id;
            this.organization_id = transunion_property_id;
            var _applicant$person = this.applicant.person,
                first_name = _applicant$person.first_name,
                last_name = _applicant$person.last_name,
                email = _applicant$person.email,
                address = _applicant$person.address,
                city = _applicant$person.city,
                state = _applicant$person.state,
                postal = _applicant$person.postal,
                dob = _applicant$person.dob,
                phone = _applicant$person.phone;

            this.residentIdentity.firstName = first_name;
            this.residentIdentity.lastName = last_name;
            this.residentIdentity.email = email;
            this.residentIdentity.phone = phone;
            this.identity = !!this.applicant.resident_identity_verification;
            this.residentIdentity.questions = this.identity ? JSON.parse(this.applicant.resident_identity_verification.questions) : '';
            this.residentIdentity.dateOfBirth = dob && dob !== "null" ? moment(dob).format("MM/DD/YYYY") : '';
            this.addresses = [];
            this.addresses.push({ city: city, state: state && state !== "null" ? this.getStates().filter(function (_ref) {
                    var label = _ref.label,
                        value = _ref.value;
                    return label.toLowerCase() === state.toLowerCase() || value.toLowerCase() === state.toLowerCase();
                })[0] : this.getDefaultSelection(), postalCode: postal, streetAddress: address, country: this.getCountries()[0], addressType: this.getAddressType()[0] });
        },
        cancel: function cancel() {
            Object.assign(this.$data, this.$options.data.apply(this));
            Event.$emit("close-slide", this.modalName);
        },
        getCountries: function getCountries() {
            return [{ label: "USA", value: "USA" }];
        },
        getAddressType: function getAddressType() {
            return [{ label: "Current ", value: "Current" }, { label: "Previous ", value: "Previous " }];
        },
        getStates: function getStates() {
            return [{
                "value": "AL",
                "label": "Alabama"
            }, {
                "value": "AK",
                "label": "Alaska"
            }, {
                "value": "AZ",
                "label": "Arizona"
            }, {
                "value": "AR",
                "label": "Arkansas"
            }, {
                "value": "CA",
                "label": "California"
            }, {
                "value": "CO",
                "label": "Colorado"
            }, {
                "value": "CT",
                "label": "Connecticut"
            }, {
                "value": "DE",
                "label": "Delaware"
            }, {
                "value": "DC",
                "label": "District of Columbia"
            }, {
                "value": "FL",
                "label": "Florida"
            }, {
                "value": "GA",
                "label": "Georgia"
            }, {
                "value": "HI",
                "label": "Hawaii"
            }, {
                "value": "ID",
                "label": "Idaho"
            }, {
                "value": "IL",
                "label": "Illinois"
            }, {
                "value": "IN",
                "label": "Indiana"
            }, {
                "value": "IA",
                "label": "Iowa"
            }, {
                "value": "KS",
                "label": "Kansas"
            }, {
                "value": "KY",
                "label": "Kentucky"
            }, {
                "value": "LA",
                "label": "Louisiana"
            }, {
                "value": "ME",
                "label": "Maine"
            }, {
                "value": "MD",
                "label": "Maryland"
            }, {
                "value": "MA",
                "label": "Massachusetts"
            }, {
                "value": "MI",
                "label": "Michigan"
            }, {
                "value": "MN",
                "label": "Minnesota"
            }, {
                "value": "MS",
                "label": "Mississippi"
            }, {
                "value": "MO",
                "label": "Missouri"
            }, {
                "value": "MT",
                "label": "Montana"
            }, {
                "value": "NE",
                "label": "Nebraska"
            }, {
                "value": "NV",
                "label": "Nevada"
            }, {
                "value": "NH",
                "label": "New Hampshire"
            }, {
                "value": "NJ",
                "label": "New Jersey"
            }, {
                "value": "NM",
                "label": "New Mexico"
            }, {
                "value": "NY",
                "label": "New York"
            }, {
                "value": "NC",
                "label": "North Carolina"
            }, {
                "value": "ND",
                "label": "North Dakota"
            }, {
                "value": "OH",
                "label": "Ohio"
            }, {
                "value": "OK",
                "label": "Oklahoma"
            }, {
                "value": "OR",
                "label": "Oregon"
            }, {
                "value": "PA",
                "label": "Pennsylvania"
            }, {
                "value": "PR",
                "label": "Puerto Rico"
            }, {
                "value": "RI",
                "label": "Rhode Island"
            }, {
                "value": "SC",
                "label": "South Carolina"
            }, {
                "value": "SD",
                "label": "South Dakota"
            }, {
                "value": "TN",
                "label": "Tennessee"
            }, {
                "value": "TX",
                "label": "Texas"
            }, {
                "value": "UT",
                "label": "Utah"
            }, {
                "value": "VT",
                "label": "Vermont"
            }, {
                "value": "VA",
                "label": "Virginia"
            }, {
                "value": "VI",
                "label": "Virgin Island"
            }, {
                "value": "WA",
                "label": "Washington"
            }, {
                "value": "WV",
                "label": "West Virginia"
            }, {
                "value": "WI",
                "label": "Wisconsin"
            }, {
                "value": "WY",
                "label": "Wyoming"
            }];
        },
        addressValidate: function addressValidate() {
            var address = this.addresses[0].streetAddress;
            var regex = /^[a-zA-Z0-9-#\s]*$/;
            if (!address) {
                this.validateAddress.isError = true;
                this.validateAddress.errorMessage = 'This field is required';
            } else if (!regex.test(address)) {
                this.validateAddress.isError = true;
                this.validateAddress.errorMessage = 'You can only enter letters, numbers, dash, hash, and space';
            } else {
                this.validateAddress.isError = false;
                this.validateAddress.errorMessage = '';
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ResidentIdentityVerification.vue
// module id = JQmD
// module chunks = 0 1